import { Navigate  } from 'react-router-dom'

import useAuthSession from '../../../hooks/useAuthSession'
import { ROUTES } from '../../../constants/routes'

const PrivateRoute = ({ element }) => {
  const user = useAuthSession()

  return(
    user?.accessToken ? element : <Navigate to={ROUTES.LOGIN}></Navigate>
  )
}

export default PrivateRoute
